export default "/app/global-wrapper-client/static/e4823df594d2426c314a620cdfcd7d7f.ttf";